import { Link } from "react-router-dom";
import styled from "styled-components";

export const ContainerPaso = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  .linear-separation {
    background: linear-gradient(
      180deg,
      #c4c4c4 0%,
      rgba(196, 196, 196, 0) 100%
    );
    width: 100%;
    height: 4px;
    mix-blend-mode: multiply;
    opacity: 0.25;
  }
`;

export const TopContainerPASO = styled.div`
  width: 100%;
  height: 80px;
  background-color: var(--color-white);
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: sticky;
  top: 0;
  h1 {
    font-size: 18px;
    margin: 10px;
    font-weight: 500;
  }
`;

export const Button = styled(Link)`
  font-size: 18px;
  margin: 10px;
  color: var(--color-black);
  text-decoration: none;
  font-weight: 500;
`;

export const BodyContainerPASO = styled.div`
  flex: 1;
  overflow-y: auto;
  .logo-dim {
    position: absolute;
    bottom: 0;
    right: 0;
    z-index: -2;
  }
`;

export const HeaderBar = styled.div`
  position: relative;
  width: 100%;
  height: 100px;
  color: var(--color-white);
  background-color: var(--color-latex10);
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  border-top: 4px solid var(--color-primary);

  .title {
    /* font-weight: 700;
    font-size: 20px;
    line-height: 150%;
    font-style: normal; */
    text-transform: uppercase;
    margin-bottom: 5px;
    /* margin-top: 19px; */
  }
  p {
    width: 70%;
    text-align: center;
  }

  h1 {
    padding: 0;
    margin: 0;
    text-align: center;
  }
  .container-ellipse {
    width: 100%;
    height: max-content;
    /* background-color: red; */
    position: absolute;
    bottom: -50%;
    margin: auto;
    right: 0;
  }

  .arrow {
    font-size: 40px;
    position: absolute;
    left: 0;
    padding-left: 10px;
  }

  ${({ circle }) =>
    circle === 1
      ? `
    
    ::after {
        content: "";
        position: absolute;
        width: 100%;
        left: 0vh;
        height: 20px;
        bottom: -8px;
        z-index: -1;
        border-radius: 50%;
        background-color: var(--color-latex10);
    }

    
    
    `
      : "border-bottom: 4px solid var(--color-primary); height: 55px; "}
`;
